var _style, _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{display:inline;fill:#FFFFFF;}\r\n\t.st4{opacity:0.3;fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 12.5,
    cy: 7.2,
    r: 4.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.5,22.4v-0.8c0-3.8-2.4-7.1-5.8-8.3c-0.4-0.1-0.9,0-1.2,0.3L15.1,14c-1.4,1.4-3.7,1.4-5.2,0l-0.4-0.4 c-0.3-0.3-0.8-0.4-1.2-0.3c-3.4,1.2-5.8,4.5-5.8,8.3v0.8H22.5z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M23.8,7.7c0,0-0.2-1.7-0.9-2.4c-0.9-1-1.9-1-2.3-1c-3.2-0.2-8-0.2-8-0.2h0c0,0-4.8,0-8,0.2 C4,4.4,3,4.4,2.1,5.3C1.5,6,1.2,7.7,1.2,7.7S1,9.6,1,11.6v0.2v1.6c0,1.9,0.2,3.9,0.2,3.9s0.2,1.7,0.9,2.4c0.9,1,2,0.9,2.5,1 c1.8,0.2,7.8,0.2,7.8,0.2s4.8,0,8.1-0.3c0.5-0.1,1.4-0.1,2.3-1c0.7-0.7,0.9-2.4,0.9-2.4s0.2-1.9,0.2-3.9v-1.5v-0.3 C24,9.6,23.8,7.7,23.8,7.7z M16.9,12.3l-7.4,4l0-6.1V8.3l3.3,1.8L16.9,12.3z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M19,2.8H6C4.2,2.8,2.8,4.2,2.8,6v13c0,1.8,1.5,3.2,3.2,3.2h6.2v-8.1H9.6v-2.7h2.7V9.8c0-2.4,1.8-4.4,4-4.4h2.7 v2.6h-2.7c-0.3,0-0.7,0.4-0.7,1v2.4h3.3v2.7h-3.3v8.1H19c1.8,0,3.2-1.5,3.2-3.2V6C22.2,4.2,20.8,2.8,19,2.8z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.8,22.7H7.2c-2.4,0-4.4-1.9-4.4-4.3v-12c0-2.4,2-4.3,4.4-4.3h11.6c2.4,0,4.4,1.9,4.4,4.3v12 C23.2,20.8,21.2,22.7,18.8,22.7 M7.2,3.9c-1.4,0-2.6,1.1-2.6,2.5v12c0,1.4,1.2,2.5,2.6,2.5h11.6c1.4,0,2.6-1.1,2.6-2.5v-12 c0-1.4-1.2-2.5-2.6-2.5H7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13,17.8c-2.9,0-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3c2.9,0,5.3,2.4,5.3,5.3C18.3,15.4,15.9,17.8,13,17.8  M13,8.9c-2,0-3.6,1.6-3.6,3.6c0,2,1.6,3.6,3.6,3.6c2,0,3.6-1.6,3.6-3.6C16.6,10.5,15,8.9,13,8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M20,6.9c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C19.4,5.6,20,6.2,20,6.9"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 15,
    cy: 15,
    r: 14.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 15,
    cy: 8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15,24.7L15,24.7c-1.4,0-2.5-1.1-2.5-2.5v-7.5c0-1.4,1.1-2.5,2.5-2.5h0c1.4,0,2.5,1.1,2.5,2.5v7.5 C17.5,23.5,16.4,24.7,15,24.7z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIInfo);
export default __webpack_public_path__ + "static/media/i-info.6c17497ec0c4e337063460f3c67fab1f.svg";
export { ForwardRef as ReactComponent };